import { render, staticRenderFns } from "./pdfdoc.vue?vue&type=template&id=cff4b55a&scoped=true&"
import script from "./pdfdoc.vue?vue&type=script&lang=js&"
export * from "./pdfdoc.vue?vue&type=script&lang=js&"
import style0 from "./pdfdoc.vue?vue&type=style&index=0&id=cff4b55a&lang=scss&scoped=true&"
import style1 from "./pdfdoc.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff4b55a",
  null
  
)

export default component.exports